import { FieldTypes, BelongsCreatedByRefField } from 'drapcode-constant';

export const processRediretRule = (data, rowObj) => {
  const bodyData = data.map((row) => {
    if (row.id === rowObj.id) {
      row.fieldValue = rowObj.fieldValue;
      row.modal = rowObj.modal;
    }
    return row;
  });

  if (data[data.length - 1].id === rowObj.id) {
    let newId = rowObj.id + 1;
    let newRow = {
      id: newId,
      fieldValue: '',
      modal: '',
    };
    bodyData.push(newRow);
  }
  return bodyData;
};

export const getFilteredArray = (array) => {
  let filterArr = [];
  for (let i = 0; i < array.length; i++) {
    if (
      array[i].fieldValue &&
      array[i].fieldValue != '' &&
      array[i].modal &&
      array[i].modal != ''
    ) {
      filterArr.push(array[i]);
    }
  }
  return filterArr;
};

export const getSessionOptions = (collections, fieldType) => {
  let options = [];
  const userCollection = collections ? collections.find((e) => e.collectionName === 'user') : null;
  if (userCollection) {
    const { fields } = userCollection;
    const nestedFields = getInnerFieldOptions(fields, collections, 'session', fieldType);
    const fieldOptions = fields
      ? fields
          .filter((e) => e.type === fieldType)
          .map((item) => {
            const fieldData = {
              fieldFrom: 'session',
              collectionName: userCollection.collectionName,
              fieldName: item.fieldName,
            };
            return {
              value: JSON.stringify(fieldData),
              label: `Current LoggedIn User:${item.fieldTitle.en}`,
            };
          })
      : [];
    options = [...fieldOptions, ...nestedFields];
  }
  return options;
};

export const getInnerFieldOptions = (fields, collections, fieldFrom, fieldType) => {
  let nestedFields = [];
  const referenceFields = fields
    ? fields.filter((field) => BelongsCreatedByRefField.includes(field.type))
    : [];
  if (referenceFields.length > 0) {
    referenceFields.map((field) => {
      if (field.type === FieldTypes.createdBy.id && !field.refCollection) {
        field.refCollection = {
          collectionName: 'user',
          collectionField: 'userName',
          displayType: 'dropdown',
        };
      }
      let { collectionName } = field.refCollection;
      let refFields = [];

      const refrenceCollection = collections
        ? collections.find((e) => e.collectionName === collectionName)
        : null;
      refFields =
        refrenceCollection && refrenceCollection.fields
          ? refrenceCollection.fields
              .filter((e) => e.type === fieldType)
              .map((nestedField) => {
                const fieldData = {
                  fieldFrom: fieldFrom,
                  fieldName: field.fieldName + '.' + nestedField.fieldName,
                  collectionName: refrenceCollection.collectionName,
                };
                return {
                  value: JSON.stringify(fieldData),
                  label:
                    fieldFrom === 'session'
                      ? `Current LoggedIn User:${field.fieldTitle.en}:${nestedField.fieldTitle.en}`
                      : field.fieldTitle.en + ':' + nestedField.fieldTitle.en,
                };
              })
          : [];
      nestedFields = [...nestedFields, ...refFields];
    });
  }
  return nestedFields;
};

export const getEventCollectionFieldOptions = (eventCollectionName, collections, fieldType) => {
  let options = [];
  const eventCollection = collections
    ? collections.find((e) => e.collectionName === eventCollectionName)
    : null;
  if (eventCollection) {
    const { fields } = eventCollection;
    const nestedFields = getInnerFieldOptions(fields, collections, 'eventCollection', fieldType);
    const fieldOptions = fields
      ? fields
          .filter((e) => e.type === fieldType)
          .map((item) => {
            const fieldData = {
              fieldFrom: 'eventCollection',
              collectionName: eventCollection.collectionName,
              fieldName: item.fieldName,
            };
            return {
              value: JSON.stringify(fieldData),
              label: item.fieldTitle.en,
            };
          })
      : [];
    options = [...fieldOptions, ...nestedFields];
  }
  return options;
};

export const collectionItemOption = {
  value: JSON.stringify({
    fieldFrom: 'currentCollectionItem',
    collectionName: 'PARENT_COLLECTION',
    fieldName: 'ITEM_ID',
  }),
  label: 'Id',
};
export const modalCollectionOption = {
  value: JSON.stringify({
    fieldFrom: 'session',
    collectionName: 'MODAL_COLLECTION',
    fieldName: 'ITEM_ID',
  }),
  label: 'Current Modal Item Id',
};
export const previousStepOption = {
  value: JSON.stringify({
    fieldFrom: 'previousStepCollectionItemId',
    collectionName: 'PREVIOUS_STEP_COLLECTION',
    fieldName: 'ITEM_ID',
  }),
  label: 'Previous Step Item Id',
};

export const createActionSettingsSchema = (actionData, eventAction) => {
  let schema = {};
  actionData.args.forEach((args) => {
    const dbParameters = eventAction.parameters.find((param) => {
      return param.name === args.name;
    });

    schema[args.name] = dbParameters
      ? dbParameters.value
      : args.name === 'collectionFrom'
      ? 'collections'
      : '';
  });
  return schema;
};

export const collectionOptions = (events) => {
  let options = [{ value: '', label: 'Choose Collection' }];
  let collections = events ? events.collections : [];
  if (collections.length > 0) {
    options = options.concat(
      collections.map((collection) => {
        return { value: collection.collectionName, label: collection.collectionTitle };
      }),
    );
  }
  return options;
};

export const collectionFieldOptions = (collectionName, events) => {
  let collections = events ? events.collections : [];
  let selectedCollection = collections.find((e) => e.collectionName === collectionName);
  let selectedFields = selectedCollection ? selectedCollection.fields : [];
  selectedFields = selectedFields.filter((e) =>
    ['static_option', 'dynamic_option'].includes(e.type),
  );
  let collectionFieldOptions = [{ value: '', label: 'Choose Field' }];
  if (selectedFields.length > 0) {
    collectionFieldOptions = collectionFieldOptions.concat(
      selectedFields.map((field) => {
        return { value: field.fieldName, label: field.fieldTitle.en };
      }),
    );
  }
  return collectionFieldOptions;
};

export const getPageOptions = (events) => {
  const { pages } = events;
  const pageOptions =
    pages.length > 0 ? pages.map((item) => ({ value: item.slug, label: item.name })) : [];
  return pageOptions;
};

export const getSelectOption = () => {
  let options = [
    { value: 'collections', label: 'Collection binded with Data Group/List/Table' },
    { value: 'collectionForm', label: 'Collection binded with Collection Form' },
    { value: 'page', label: 'Collection binded with Page/Snippet' },
    { value: 'session', label: 'Current Logged In User' },
    {
      value: 'sessionActionResponse',
      label: 'Browser Session',
    },
  ];
  return options;
};
